<template>
  <div class="home" @click="handleClick">
    <div v-if="!isMaxScreen" class="main-content">
      <AppHead
        ref="head"
        title="Shipping lable"
        :isShowBack="isFinish2 || isFinish3"
        :backFn="back"
      ></AppHead>
      <step :isFinish0="isFinish0" :isFinish1="isFinish1" :isFinish2="isFinish2" :isFinish3="isFinish3"></step>

      <div class="top-section">
        <div>
          <h5 class="margin0">
            {{
              !isFinish2
                ? $t('shippingLable.shippingLable.649fhwpa2100')
                : $t('shippingLable.shippingLable.649fhwpa2880')
            }}
          </h5>
          <div v-if="!isFinish2" class="upload">
            <div class="schematic-box">
              <span class="schematic-text">Schematic</span>
              <img src="../../assets/image/upload/package_exp.png" alt="" class="demo-img" />
            </div>

            <uploadPhoto @changeImeiPhoto="changeImeiPhoto"></uploadPhoto>
          </div>
          <div v-else class="upload">
            <div class="schematic-box">
              <div class="demo-img">
                <img :src="fileList[0].url" alt="" class="demo-img2" />
              </div>
            </div>
          </div>

          <h5 class="tipText">{{ $t('shippingLable.shippingLable.649fhwpasf3s') }}</h5>
          <span class="text"> {{ $t('shippingLable.shippingLable.649fhwpaa6f3') }}</span>

          <h5 class="tipText">{{ $t('shippingLable.shippingLable.649fhwpa2h80') }}</h5>
          <span class="text">
            {{ $t('shippingLable.shippingLable.649fhwpa2qk0') }}
          </span>
          <span class="text">{{ $t('shippingLable.shippingLable.649fhwpa3fk0') }}</span>
          <span class="text">{{ $t('shippingLable.shippingLable.649fhwpa3v40') }}</span>
        </div>
      </div>
      <div class="footer-btn">
        <template v-if="isFinish2">
          <van-button class="btn1" @click="inquire">{{
            $t('shippingLable.shippingLable.649fhwpa42s0')
          }}</van-button>
          <van-button class="btn2" @click="startPolling">{{
            $t('shippingLable.shippingLable.649fhwpa4as0')
          }}</van-button>
        </template>
        <template v-else>
          <van-button class="btn" :disabled="!isFinish1" @click="submit">{{
            $t('shippingLable.shippingLable.649fhwpa4jo0')
          }}</van-button>
        </template>
      </div>
    </div>
    <div v-else class="pc_main-content">
      <AppHead ref="head" :backFn="back"></AppHead>
      <step :isFinish0="isFinish0" :isFinish1="isFinish1" :isFinish2="isFinish2" :isFinish3="isFinish3"></step>
      <div class="top-section">
        <div>
          <h5 class="margin0 textcenter">
            {{
              isFinish2
                ? $t('shippingLable.shippingLable.649fhwpa2880')
                : $t('shippingLable.shippingLable.649fhwpa2100')
            }}
          </h5>
          <div v-if="!isFinish2" class="upload">
            <div class="schematic-box">
              <span class="schematic-text">Schematic</span>
              <img src="../../assets/image/upload/package_exp.png" alt="" class="demo-img" />
            </div>

            <custom-upload
              ref="cardUpload"
              :limit="1"
              :urlList="fileList"
              accept="image/png,image/jpeg,image/jpg"
              :multiple="true"
              @change="handleUploadCardChange"
            >
            </custom-upload>
          </div>
          <div v-else class="upload">
            <div class="schematic-box">
              <!-- <img :src="fileList[0].url" alt="" class="demo-img"> -->
              <el-image
                class="demo-img"
                :src="fileList[0].url"
                :preview-src-list="[fileList[0].url]"
              >
              </el-image>
            </div>
          </div>
          <h5 class="tipText">{{ $t('shippingLable.shippingLable.649fhwpasf3s') }}</h5>
          <span class="text"> {{ $t('shippingLable.shippingLable.649fhwpaa6f3') }}</span>

          <h5 class="tipText">{{ $t('shippingLable.shippingLable.649fhwpa2h80') }}</h5>
          <span class="text">
            {{ $t('shippingLable.shippingLable.649fhwpa2qk0') }}
          </span>
          <span class="text">{{ $t('shippingLable.shippingLable.649fhwpa3fk0') }}</span>
          <span class="text">{{ $t('shippingLable.shippingLable.649fhwpa3v40') }}</span>
        </div>
      </div>
      <div class="footer-btn">
        <template v-if="isFinish2">
          <el-button class="btn1" @click="inquire">{{
            $t('shippingLable.shippingLable.649fhwpa42s0')
          }}</el-button>
          <el-button class="btn2" @click="startPolling">{{
            $t('shippingLable.shippingLable.649fhwpa4as0')
          }}</el-button>
        </template>
        <template v-else>
          <el-button class="btn" type="warning" :disabled="!isFinish1" @click="submit">{{
            $t('shippingLable.shippingLable.649fhwpa4jo0')
          }}</el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import successIcon from '../../assets/image/upload/2.png';
import AppHead from '../../components/head';
import step from '../../components/step';
const uploadPhoto = () => import('./uploadPhoto.vue');
import {
  getExpressBill,
  getOldImeiPic,
  orderDetail,
  submit} from '../../services/api/brandList.js';
import customUpload from './../../components/common-upload/index.vue';
export default {
  name: 'shippingLable',
  components: {
    customUpload,
    uploadPhoto,
    AppHead,
    step
  },
  data() {
    return {
      fileList: [],
      fileList1: [],
      successIcon,
      isFinish0: true,
      isFinish1: false, // 第一步
      isFinish2: false, // 第二步
      isFinish3: false, // 第三步 currentStatus: 3
      intervalId: null,
      pollCount: 0,
      maxPollCount: 3,
      orderDetailInfo: {},
      upsLink: {
        AT: 'https://www.ups.com/dropoff?loc=en_AT',
        BE: 'https://www.ups.com/dropoff?loc=en_BE',
        BG: 'https://www.ups.com/bg/en/locations.page',
        HR: 'https://www.ups.com/hr/en/locations.page',
        CY: 'https://www.ups.com/cy/en/locations.page',
        CZ: 'https://www.ups.com/dropoff?loc=en_CZ',
        DK: 'https://www.ups.com/dropoff?loc=en_DK',
        EE: 'https://www.ups.com/ee/en/locations.page',
        FI: 'https://www.ups.com/dropoff?loc=en_FI',
        FR: 'https://www.ups.com/dropoff?loc=en_FR',
        DE: 'https://www.ups.com/dropoff?loc=en_DE',
        GR: 'https://www.ups.com/gr/en/locations.page',
        HU: 'https://www.ups.com/dropoff?loc=en_HU',
        IE: 'https://www.ups.com/ie/en/home',
        IT: 'https://www.ups.com/dropoff?loc=en_IT',
        LV: 'https://www.ups.com/lv/en/locations.page',
        LT: 'https://www.ups.com/lt/en/locations.page',
        LU: 'https://www.ups.com/dropoff?loc=en_LU',
        MT: 'https://www.ups.com/mt/en/locations.page',
        NL: 'https://www.ups.com/dropoff?loc=en_NL',
        PL: 'https://www.ups.com/dropoff?loc=en_PL',
        PT: 'https://www.ups.com/dropoff?loc=en_PT',
        RO: 'https://www.ups.com/ro/en/locations.page',
        SK: 'https://www.ups.com/sk/en/locations.page',
        SI: 'https://www.ups.com/si/en/locations.page',
        SE: 'https://www.ups.com/dropoff?loc=en_SE',
        GB: 'https://www.royalmail.com/services-near-you?iid=RM0624_NAV_PERS_QL_SNY#/',
        ES: `https://www.correos.es/es/es/herramientas/oficinas-buzones-citypaq/detalle?query=${this.$route.query.postCode}&searchtype=${this.$route.query.searchType}`
      }
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  created() {
    // this.data = this.$route.query
    console.log(this.$route.query);
  },
  mounted() {
    this.getOldImeiPic();
    this.getOrderDetail();
  },
  methods: {
    handleClick() {
      this.$refs.head.hidLangeList();
    },
    changeImeiPhoto(url) {
      if (url) {
        this.isFinish1 = true;
      } else {
        this.isFinish1 = false;
      }
      this.fileList = [
        {
          url
        }
      ];
    },
    back() {
      const currentURL = window.location.href;
      const queryString = currentURL.split('?')[1];
      this.$router.push('/order?' + queryString);
    },
    getOldImeiPic() {
      getOldImeiPic({})
        .then(res => {
          console.log(res);
          if (res.data) {
            this.fileList.push({
              url: res.data
            });
            this.isFinish1 = true;
            this.isFinish2 = true;
          }
        })
        .catch(() => {});
    },
    handleUploadCardChange(val) {
      console.log('val', val);
      this.fileList = [];
      if (val.length > 0) {
        this.fileList.push({
          url: val[0].response
        });
        this.isFinish1 = true;
      }
    },
    inquire() {
      // const query = '';
      // const searchtype = '';
      // const url = `https://www.correos.es/es/es/herramientas/oficinas-buzones-citypaq/detalle?query=${query}&searchtype=${searchtype}`;
      const url = this.upsLink[this.$route.query.countryCode];
      window.open(url, '_blank');
    },
    // 提交
    submit() {
      const urlList = this.fileList.map(item => item.url);
      submit({
        urlList
      })
        .then(res => {
          if (res.code == '0000') {
            this.$toast(this.$t('shippingLable.shippingLable.649fhwpa4to0'));
            this.isFinish2 = true;
          }
        })
        .catch(() => {});
    },
    afterRead(files, detail) {},
    beforeDelete(files, detail) {
      this.fileList = [];
    },
    startPolling() {
      this.stopPolling();
      this.pollCount = 0; // 重置轮询计数器
      this.intervalId = setInterval(() => {
        if (this.pollCount < this.maxPollCount) {
          this.handlePanel();
          this.pollCount++;
        } else {
          this.stopPolling(); // 达到最大轮询次数后停止轮询
        }
      }, 1000);
    },
    handlePanel() {
      getExpressBill({ mailNo: this.$route.query.mailNo || '' })
        .then(res => {
          if (res.code == '0000' && res.data) {
            window.location.href = res.data;
            this.$toast(this.$t('shippingLable.shippingLable.649fhwpa4yk0'));
            this.stopPolling();
          }
        })
        .catch(() => {});
      //
    },
    stopPolling() {
      clearInterval(this.intervalId);
    },
    getOrderDetail() {
      orderDetail()
        .then(res => {
          if (res.code == '0000') {
            this.orderDetailInfo = res.data;
            this.isFinish3 = false;
            if (res.data) {
              this.isFinish3 = [2, 3, 4].includes(res.data.logisticsInfo.currentStatus);
            }
          }
        })
        .catch(() => {});
    }
  },
  beforeDestroy() {
    this.stopPolling();
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .main-content {
    padding-top: 100px;
    padding-bottom: 140px;
  }
  .footer-btn {
    height: 140px;
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    background-color: #fff;
    border: none;

    .btn {
      height: 100px;
      border-radius: 10px;
      border: none;
      width: 700px;
      background: var(---Brand-1, #ff9600);
      color: #fff;
      font-size: 32px;
    }

    .btn1 {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 100px;
      border-radius: 20px;
      border: 1px solid #ff9600;
      flex: 1;
      color: #ff9600;
      background-color: #fff;
      font-size: 32px;
      margin: 0 24px;
    }

    .btn2 {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 100px;
      border-radius: 20px;
      border: none;
      flex: 1;
      background: var(---Brand-1, #ff9600);
      color: #fff;
      font-size: 32px;
      margin-right: 24px;
    }
  }

  h5 {
    text-align: left;
    color: #333;
    font-family: 'PingFang SC';
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 20px 0 20px;
  }

  .steps {
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    margin-top: 26px;
    margin-bottom: 20px;

    .step {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      color: #8f949d;
      // width: 33.33%;
      width: 25%;
      flex-shrink: 0;
      .step-text {
        // width: 156px;
        // height: 68px;
        padding: 0 20px;
      }
      .step-text2 {
        // width: 106px;
      }
    }

    .circle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 46px;
      height: 46px;
      line-height: 46px;
      margin-bottom: 16px;
      background-color: #e9e7e7;
      border-radius: 100%;
      text-align: center;
      z-index: 100;
      color: #8f949d;
    }

    .circle-img {
      width: 30px;
      height: 30px;
    }

    .circlePosition {
      position: relative;

      .blank {
        position: absolute;
        left: 44px;
        top: 18px;
        // width: calc(500%);
        width: calc(400%);
        height: 10px;
        background-color: #e9e7e7;
        &.finish {
          background-color: #d6f4e9;
        }
      }
    }
  }

  .top-section {
    margin: 24px;
    padding: 0 24px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
  }

  .demo-img2 {
    width: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #f7f7f7;
    border-radius: 16px;
    overflow: hidden;
  }

  .demo-img,
  .upload-box {
    width: 320px;
    height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #f7f7f7;
    border-radius: 16px;
    overflow: hidden;
    position: relative;

    span {
      color: #999;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 16px;
    }

    .upload-icon {
      width: 80px;
      height: 80px;
    }

    /deep/.van-uploader__preview {
      margin: 0;
      position: static;
    }

    /deep/.van-uploader__preview-image {
      width: 100%;
      height: 100%;
    }

    /deep/.van-uploader__preview-delete {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /deep/.van-uploader__preview-delete-icon {
      position: absolute;
      top: -1px;
      right: -1px;
      color: #fff;
      font-size: 20px;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
  }

  .upload {
    display: flex;
    justify-content: space-between;
  }

  .text {
    text-align: left;
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
    font-size: 24px;
    color: #8f949d;
  }

  .tipText {
    color: #333;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .schematic-box {
    position: relative;

    .schematic-text {
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 8px 0px 8px 0;
      opacity: 0.6;
      background: #333;
      color: #fff;
      font-size: 24px;
      z-index: 100;
    }
  }
}

@media (min-width: 981px) {
  .home {
    background-color: #fff;
    min-height: 100vh;
  }
  .pc_main-content {
    padding-top: 110px;
  }
  .footer-btn {
    height: 140px;
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    background-color: #fff;
    border: none;
    margin: 0 auto;

    .btn {
      height: 75px;
      border-radius: 10px;
      border: none;
      width: 500px;
      // background: var(---Brand-1, #FF9600);
      color: #fff;
      font-size: 24px;
    }

    .btn1 {
      height: 75px;
      border-radius: 10px;
      border: 1px solid #ff9600;
      //width: 240px;
      color: #ff9600;
      background-color: #fff;
      font-size: 24px;
      margin-right: 20px;
    }

    .btn2 {
      height: 75px;
      border-radius: 10px;
      border: none;
      //width: 240px;
      background: var(---Brand-1, #ff9600);
      color: #fff;
      font-size: 24px;
    }
  }

  .back {
    color: #333;
    font-family: 'PingFang SC';
    font-size: 14px;
    font-weight: 500;
    position: absolute;
    left: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
    }
  }

  h5 {
    text-align: left;
    color: #333;
    font-family: 'PingFang SC';
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 0px 0 20px;
  }

  .textcenter {
    text-align: center;
    margin: 0px 0 30px;
  }

  .step-box {
    height: 120px;
    background-color: #f7f7f7;
    display: flex;
    justify-content: center;
  }

  .width1200 {
    width: 1680px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .step-center {
      display: flex;
      align-items: center;
      color: var(---Text-3, #8f949d);
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      .step {
        font-size: 18px;
        display: flex;
        align-items: center;
        flex: 1;
      }

      .circlePosition {
        width: 34px;
        height: 34px;
        flex-shrink: 0;
        border-radius: 50%;
        background-color: #e8e7e7;
        margin-right: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .circle-img {
        width: 30px;
        height: 30px;
      }

      .horizontal-bar {
        width: 125px;
        height: 2px;
        flex-shrink: 0;
        background: #e9e7e7;
        margin: 0 30px;
      }

      .horizontal-bar2 {
        background: #d6f4e9;
      }
      .horizontal-bar3 {
        background: #d6f4e9;
      }
    }
  }

  .top-section {
    margin: 24px;
    padding: 0 24px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    width: 655px;
    margin: 75px auto 0;
  }

  .demo-img,
  .upload-box {
    width: 320px;
    height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: #f7f7f7;
    border-radius: 16px;
    overflow: hidden;

    span {
      color: #999;
      text-align: center;
      font-family: 'PingFang SC';
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 16px;
    }

    .upload-icon {
      width: 80px;
      height: 80px;
    }
  }

  .upload {
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;
  }

  .text {
    text-align: left;
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
    font-size: 21px;
    color: #8f949d;
  }

  .schematic-box {
    position: relative;

    .schematic-text {
      position: absolute;
      left: 0;
      top: 0;
      border-radius: 8px 0px 8px 0;
      opacity: 0.6;
      background: #333;
      color: #fff;
      font-size: 24px;
    }
  }
}
</style>
